const state = {
    // 专利权利分类
    patentRightType: [
        { label: '0', value: '自主研发' },
        { label: '1', value: '转入' },
        { label: '2', value: '转出' },
    ],
    // 开庭公告 - 身份
    identityType: [
        { label: '0', value: '原告' },
        { label: '1', value: '被告' },
        { label: '2', value: '上诉人' },
        { label: '3', value: '第三人' },
        { label: '4', value: '被执行人' },
        { label: '5', value: '被上诉人' },
        { label: '6', value: '申请人' },
        { label: '7', value: '被申请人' },
        { label: '8', value: '其他' },
    ],
    // 企业被执行状态
    statusType: [
        { label: '0', value: '执行中' },
        { label: '1', value: '已结案' },
        { label: '2', value: '其他' },
    ],
};

export default {
    namespaced: true,
    state,
};



// WEBPACK FOOTER //
// ./src/store/modules/dict.js